import { render, staticRenderFns } from "./SKDataTableRow.vue?vue&type=template&id=2d30afe6&scoped=true&"
import script from "./SKDataTableRow.vue?vue&type=script&lang=js&"
export * from "./SKDataTableRow.vue?vue&type=script&lang=js&"
import style0 from "./SKDataTableRow.vue?vue&type=style&index=0&id=2d30afe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30afe6",
  null
  
)

export default component.exports